<div class="toggle" [ngClass]="{'on': value === true}" (click)="onToggleSwitch()">
  <div class="toggle-dot"></div>
</div>
